module.exports = __webpack_public_path__ + "img/maintenance-icon.a6d6023b.png";